import { Component, OnInit,ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthConstants } from 'src/app/config/auth-constants';
import { ToastService } from 'src/app/services/toast.service';
import { StoreService } from 'src/app/services/store.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.page.html',
  styleUrls: ['./forgot-password.page.scss'],
})
export class ForgotPasswordPage implements OnInit {
  @ViewChildren('formRow') rows: any;
  ionicForm: FormGroup;
  ionicFormPassword: FormGroup;
  form: any;
  userId: any;
  testing: any;
  select = "email";
  formInput = ['input1', 'input2', 'input3', 'input4', 'input5', 'input6'];
  isOTPReceived = false;
  isSubmitted = false;
  isSubmittedPassword = false;
  isPasswordReset = false
  constructor(private formBuilder: FormBuilder, private toast: ToastService, private router: Router, private authService: StoreService,) {
    this.ionicFormPassword = this.formBuilder.group({
      cpassword: ['', [Validators.required, Validators.minLength(5)]],
      password: ['', [Validators.required, Validators.minLength(5)]]
    });
    this.form = this.toFormGroup(this.formInput);
    this.ionicForm = this.formBuilder.group({
      email: [''],
      phone : ['']
    });
  }
  toFormGroup(elements) {
    const group: any = {};
    elements.forEach(key => {
      group[key] = new FormControl('', Validators.required);
    });
    return new FormGroup(group);
  }
  get errorControl() {
    return this.ionicForm.controls;
  }
  ngOnInit() {
  }
  keyUpEvent(event, index) {
    let pos = index;
    if (event.keyCode === 8 && event.which === 8) {
      pos = index - 1;
    } else {
      pos = index + 1;
    }
    if (pos > -1 && pos < this.formInput.length) {
      this.rows._results[pos].nativeElement.focus();
    }
  }
  onSubmit() {
    let finalOtp = this.form.value.input1 + this.form.value.input2 + this.form.value.input3 + this.form.value.input4 + this.form.value.input5 + this.form.value.input6
    console.log(finalOtp)
    //this.authService.showLoader()
    const Loginobj = {
      userId: this.userId,
      // otp:this.testing
      otp: finalOtp
    }
    this.authService.matchOtp(Loginobj).subscribe((result: any) => {
      //this.authService.hideLoader()
      console.log("Response from forgot password  API", result)
      if (result.error) {
        this.toast.presentToast(result.error)
      } else if (result.success) {
        this.isPasswordReset = true;
        this.isOTPReceived = false
        this.toast.presentToast(result.success)
      }

    }, (error: any) => {
      //this.authService.hideLoader()
      this.toast.presentToast("There is error in login time")
    })
  }
  submitForm() {

    this.isSubmitted = true;
    if (!this.ionicForm.valid) {
      //  this.authService.showLoader()
      console.log('Please provide all the required values!')
      return false;

    } else {
      // this.authService.showLoader()
      if(this.select=="email"){
      let Loginobj = {
        email: this.ionicForm.value.email,
        //phone : this.ionicForm.value.phone
      }

      this.authService.forgotPassword(Loginobj).subscribe((result: any) => {
       // this.authService.hideLoader()
        if (result.code == 0) {
          this.toast.presentToast(result.msg)
        } else if (result.useriD) {
          this.userId = result.useriD;
          this.isOTPReceived = true;
        } else {
          this.toast.presentToast(result.msg)
        }
        console.log("response from forgot password  API", result)
      }, (error: any) => {
        //  this.authService.hideLoader()
        this.toast.presentToast("There is error in login time")
      })
        }
      else{
        let Loginobj = {
          //email: this.ionicForm.value.email,
          phone : this.ionicForm.value.phone
        }
  
        this.authService.forgotPassword(Loginobj).subscribe((result: any) => {
          //this.authService.hideLoader()
          if (result.code == 0) {
            this.toast.presentToast(result.msg)
          } else if (result.useriD) {
            this.userId = result.useriD;
            this.isOTPReceived = true;
          } else {
            this.toast.presentToast(result.msg)
          }
          console.log("response from forgot password  API", result)
        }, (error: any) => {
          //  this.authService.hideLoader()
          this.toast.presentToast("There is error in login time")
        })
      }  


      // this.authService.forgotPassword(Loginobj).subscribe((result: any) => {
      //   this.authService.hideLoader()
      //   if (result.code == 0) {
      //     this.toast.presentToast(result.msg)
      //   } else if (result.useriD) {
      //     this.userId = result.useriD;
      //     this.isOTPReceived = true;
      //   } else {
      //     this.toast.presentToast(result.msg)
      //   }
      //   console.log("response from forgot password  API", result)
      // }, (error: any) => {
      //   //  this.authService.hideLoader()
      //   this.toast.presentToast("There is error in login time")
      // })
    }
  }
  submitFormPassword() {
    //this.authService.showLoader()
    this.isSubmitted = true;
    if (!this.ionicFormPassword.valid) {
      console.log('Please provide all the required values!')
      return false;
    } else {
      const Passwordobj = {
        userId: this.userId,
        Newpwd: this.ionicFormPassword.value.password,
      }
      this.authService.changePassoerd(Passwordobj).subscribe((result: any) => {
        //this.authService.hideLoader()
        this.toast.presentToast(result.success)
        this.router.navigate(['/loginn'])
        this.isOTPReceived = false;
        this.isSubmittedPassword = false;
      }, (error: any) => {
        //this.authService.hideLoader()
        this.toast.presentToast("There is internal server error")
      })
    }
  }
  goBack() {
    this.router.navigate(['/loginn'])
  }

}
